import styles from "./PropertyValue.module.scss"
import { PropertyValueProps } from "./PropertyValue.types"

export default function PropertyValue(props: PropertyValueProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
